export const summaryRows: string[] = [
  "Volume 1 — Fondamenti del Vino e dell'Enologia",
  "Volume 2 — Viticoltura: dalla Vite all'Uva",
  'Volume 3 — Scienza e Produzione del Vino',
  'Volume 4 — Affinamento, Invecchiamento e Conservazione',
  'Volume 5 — Analisi Sensoriale, Degustazione e Abbinamento',
  "Volume 6 — Regioni, Stili e Storia del Vino: dall'Italia al Mondo",
  'Bonus 1 — Schede di Degustazione Guidate',
  'Bonus 2 — Atlante dei Vitigni Italiani e Internazionali',
  'Bonus 3 — Carte di Abbinamento Cibo-Vino',
  'Bonus 4 — Glossario del Vino',
  'Bonus 5 — 300 Domande di Ripasso con Risposte',
  'Garanzia di soddisfazione di 7 giorni',
  'Accesso immediato',
];
